
import React from 'react';
import { ArrowRight } from 'lucide-react';

const GlobalHeader = () => {
  return (
    <div className="w-full bg-[#8B4513] text-white">
      {/* Skip to content link */}
      <div className="sr-only focus-within:not-sr-only">
        <a href="#main-content" className="absolute z-50 p-2 bg-white text-primary focus:block">
          Skip to main content
        </a>
      </div>
      
    </div>
  );
};

export default GlobalHeader;
